<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Çeviri Listesi">
          <!-- <b-alert variant="warning" show class="mb-0">
                <div class="alert-body mb-2">
                  <span
                    ><strong>Not:</strong> Eklenecek içerik adı ve arama motoru
                    bağlantı linki benzersiz olmalıdır...</span
                  >
                </div>
              </b-alert> -->
          <b-button
            class="float-right"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            :to="`/translation/create`"
          >
            Yeni Çeviri Ekle
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Çeviriler">
          <b-form>
            <b-row>
              <b-col cols="12">
                <table class="table b-table table-responsive">
                  <thead>
                    <th>#</th>
                    <th>KEY</th>
                    <th>ÇEVİRİLER</th>
                    <th>OLUŞTURMA TARİHİ</th>
                    <th>İŞLEMLER</th>
                  </thead>
                  <draggable
                    v-model="translations"
                    class="cursor-move"
                    tag="tbody"
                    @change="outputData"
                  >
                    <tr
                      v-if="languages.length > 0 && translations.length > 0"
                      v-for="translation in translations"
                      :key="translation.id"
                    >
                      <td>{{ translation.id }}</td>
                      <td>{{ translation.key }}</td>
                      <td class="text-center">
                        <p
                          v-for="(language, index) in languages"
                          :key="`${translation.id}-${index}-translation`"
                        >
                          {{ language.code.toUpperCase() }} :
                          {{ translation.translation[language.code] }}
                        </p>
                      </td>
                      <td>{{ translation.createdAt }}</td>
                      <td>
                        <b-button-group>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-warning"
                            class="btn-icon rounded-circle mr-1"
                            :to="`/translation/edit/${translation.id}`"
                          >
                            <feather-icon icon="EditIcon" />
                          </b-button>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-danger"
                            class="btn-icon rounded-circle"
                            @click="deleteConfirmText(translation.id)"
                          >
                            <feather-icon icon="TrashIcon" />
                          </b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </draggable>
                  <thead>
                    <th>#</th>
                    <th>KEY</th>
                    <th>ÇEVİRİLER</th>
                    <th>OLUŞTURMA TARİHİ</th>
                    <th>İŞLEMLER</th>
                  </thead>
                </table>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import draggable from "vuedraggable";
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BCardText,
  BButtonGroup,
  BListGroupItem,
  BButtonToolbar,
} from "bootstrap-vue";
import settings from "../../../settings";
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BAlert,
    BBadge,
    BButton,
    BAvatar,
    BCardText,
    BButtonGroup,
    BListGroupItem,
    BButtonToolbar,
    draggable,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      request: [],
      translations: [],
    };
  },
  watch: {},
  methods: {
    outputData() {
      this.updateSubmit();
    },
    getLanguages() {
      endpoints
        .getLanguages(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.languages = [...data.response];
          this.languages.forEach((language) => {
            this.translations.push({
              code: language.code,
              text: "",
            });
          });

          this.getTranslations();

        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTranslations() {
      endpoints
        .getTranslations(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.translations = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateSubmit() {
      Object.entries(this.translations).forEach(([key, value]) => {
        let translationsOrder = {
          id: value.id,
          order: parseInt(key),
        };
        this.request.push(translationsOrder);
      });
      endpoints
        .putLanguagesOrder({ translations: this.request }, this.$i18n.locale, () => {})
        .then((data) => {
          this.$swal({
            icon: "success",
            title: "Güncelleme başarılı!",
            text: "Çeviri sıralaması güncellendi.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteConfirmText(id) {
      this.$swal({
        title: "Sil?",
        text: "Çeviriyi silmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteSubmit(id);
        }
      });
    },
    deleteSubmit(id) {
      endpoints
        .deleteTranslation(id, this.$i18n.locale, () => {})
        .then((data) => {
          this.getTranslations();
          this.$swal({
            icon: "success",
            title: "Silme başarılı!",
            text: "Çeviri silindi",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getLanguages();
  },
};
</script>
<style>
.draggable-card {
  margin-bottom: 0;
}

.draggable-card > .card-body {
  padding: 10px;
}

.draggable-card > .card-body > .card-title {
  margin-bottom: 0;
  font-size: 1rem;
}

.tree-node {
  border: 0 !important;
}
</style>
